export default "__VITE_ASSET__CuEJaz73__"